import devicesReducer from "./reducers";

export default devicesReducer;